var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"maskClosable":false,"width":"80%","title":"默认选项","placement":"right","closable":true,"visible":_vm.visible},on:{"close":_vm.onClose}},[(_vm.visible && _vm.tenantId)?_c('defaultTable',{attrs:{"tenantId":_vm.tenantId},on:{"backTable":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }